import React, { useContext } from "react";
import { AppContext } from "../../stores/application.store";
import "./SelectPopup.scss";
const SelectPopup = () => {
  const {
    selectPopupVisble,
    setSelectPopupVisible,
    formValue,
    setFormValue,
  } = useContext(AppContext);

  const options = [
    "הקמת אתר/הקמת חנות אונליין",
    "כלי שיווק דיגיטלי לגיוס לקוחות חדשים (גוגל / פייסבוק / אינסטגרם / אאוטבריין וטאבולה)",
    "דיוור שיווקי (הקמת דיוור שיווקי במערכת דיוור / הכנת תוכן כתוב וויזואלי לדיוור שיווקי)",
    "יצירת חומרים שיווקיים (עיצוב בקנבה / כתיבה שיווקית / בניית עמוד נחיתה)",
    "הגדלת נוכחות דיגיטלית ושימוש בפלטפורמות הקידום השונות (איזי/פייבר/גוגל מיי ביזנס/גט דליברי)",
    "רשתות חברתיות (ניהול עמוד שיווק בפייסבוק / אינסטגרם / יצירת קהילה וכד')",
  ];

  return (
    <div className={`select-popup ${selectPopupVisble ? "" : "hidden"}`}>
      <div className="fade" onClick={() => setSelectPopupVisible(false)}></div>
      <div className="select-wrapper">
        <div className="select-box">
          <div
            className="x-icon"
            onClick={() => setSelectPopupVisible(false)}
          ></div>

          <div className="options">
            {options.map((value, index) => {
              return (
                <div
                  className="option"
                  key={index}
                  onClick={() => {
                    setFormValue({ ...formValue, digitalChoice: value });
                    setSelectPopupVisible(false);
                  }}
                >
                  <div className="checkbox">
                    <div
                      className={`inner ${
                        value === formValue.digitalChoice ? "selected" : ""
                      }`}
                    ></div>
                  </div>
                  <h3>{value}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectPopup;
